export default __webpack_public_path__ + "static/harry-4ecd15035ecc258b267a960dc2954259.jpg";